export const CHANGE_PASSWORDS_REQUEST = 'passwordReducer/CHANGE_PASSWORDS_REQUEST';
export const CHANGE_PASSWORDS_SUCCESS = 'passwordReducer/CHANGE_PASSWORDS_SUCCESS';
export const CHANGE_PASSWORDS_FAILED = 'passwordReducer/CHANGE_PASSWORDS_FAILED';


export const CONFIRM_PASSWORDS_REQUEST='passwordConfirmReducer/CONFIRM_PASSWORDS_REQUEST';
export const CONFIRM_PASSWORDS_SUCCESS='passwordConfirmReducer/CONFIRM_PASSWORDS_SUCCESS'
export const CONFIRM_PASSWORDS_FAILED='passwordConfirmReducer/CONFIRM_PASSWORDS_FAILED';